import React, { useEffect, useRef, useState } from "react";
import { Box, Collapse } from "@mui/material";

const AccordionWrapper = ({ isOpen = false, initialHeight = 220, children }) => {
  const contentRef = useRef(null);
  const [collapsedHeight, setCollapsedHeight] = useState(initialHeight);

  useEffect(() => {
    if (!isOpen && contentRef.current) {
      const contentHeight = contentRef.current.scrollHeight;
      setCollapsedHeight(Math.min(contentHeight, initialHeight));
    }
  }, [isOpen, initialHeight, children]);

  return (
    <Box
      sx={{
        overflow: "hidden",
        transition: "height 0.3s ease",
      }}
    >
      <Collapse in={isOpen} collapsedSize={collapsedHeight}>
        <Box ref={contentRef}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default AccordionWrapper;
